(function() {


    $(document).ready(function(){

         var path= document.getElementById("services-strategy");
        // growCog("cog1", path);
        // rotateCog("cog1", path);
        // rotateCog("cog2", path);
        $('.animatedude').click(function() {
         snap();
        });
    });


    function rotateCog(id, path) {
        var svgDoc = path.contentDocument; //get the inner DOM of alpha.svg
        var delta = svgDoc.getElementById(id); //get the inner element by id
        var animate = delta.getElementsByTagName("animateTransform")[0];

        var bbox = delta.getBBox();
        animate.setAttribute("from", "0 " + (bbox.x + (bbox.width / 2)) + " " + (bbox.y + (bbox.height / 2)));
        animate.setAttribute("to", "360 " + (bbox.x + (bbox.width / 2)) + " " + (bbox.y + (bbox.height / 2)));
    }

    function growCog(id, path) {
        // var svgDoc = path.contentDocument; //get the inner DOM of alpha.svg
        // var delta = svgDoc.getElementById(id); //get the inner element by id
        // var animate = delta.getElementsByTagName("animateTransform")[1];

        // var bbox = delta.getBBox();
        // animate.setAttribute("from", 1 + " " + 1);
        // animate.setAttribute("to",  1.5 + " " + 1.5);


    }

    function startCogAnimation(path) {
        var svgDoc = path.contentDocument; //get the inner DOM of alpha.svg
        var delta = svgDoc.getElementById('cog1'); //get the inner element by id
        var animate = delta.getElementsByTagName("animateTransform")[0];

        var delta2 = svgDoc.getElementById('cog2'); //get the inner element by id
        var animate2 = delta2.getElementsByTagName("animateTransform")[0];

        animate.beginElement();
        animate2.beginElement();
        delta = svgDoc.getElementById('strategy');

        delta.unpauseAnimations();
    }

    function endCogAnimation(path) {
        var svgDoc = path.contentDocument;

        var delta = svgDoc.getElementById('strategy');

        delta.pauseAnimations();
    }


    function snap() {

        var s = Snap("#snap");
        //lets draw 2 rects at position 100,100 and then reposition them
        Snap.load("../img/services_strategy.svg", onSVGLoaded ) ;

        function onSVGLoaded( data ){
            s.append( data );
                       var elem =s.select('#cog1');
            elem.attr({opacity:0});
            rotationAnimation(s.select('#cog1'), 360, 82,82,5000);
            // rotationAnimation(s.select('#cog2'), 360, 133,133,2000);


            var matrix = new Snap.Matrix();
            matrix.scale(1.2,1.2);
           // matrix.translate(0,0);
           // matrix.rotate(360);

         //   elem.animate({opacity:1},5000).animate({ transform: matrix }, 3000, mina.bounce);
        }
    }

    function rotationAnimation(elem, degrees, pointX, pointY, time){
        var matrix = new Snap.Matrix();
        matrix.scale(1.2,1.2);
        elem.stop();
        elem.animate({opacity:1},5000).animate({transform:"r"+[degrees,pointX,pointY]}, time, function() {
             elem.attr({ transform: 'r0,'+pointX+',' +pointY});
             rotationAnimation(elem, degrees, pointX,pointY,time);
        });
    }

    function setSVGEvents(path) {
        var svgDoc = path.contentDocument; //get the inner DOM of alpha.svg
        var circle = svgDoc.getElementById('services-strategy-circle'); //get the inner element by id
        var cog1 = svgDoc.getElementById('cog1'); //get the inner element by id
        var cog2 = svgDoc.getElementById('cog2'); //get the inner element by id

        $(cog1).attr("class", "cog active");

        // $(circle).hover(function(){
        //     startCogAnimation(path);
        // });

        // $(circle).on('mouseenter', function() {startCogAnimation(path)});

        // $(circle).on('mouseleave', function() {endCogAnimation(path)});

        // $(cog1).on('mouseenter', function() {startCogAnimation(path);});

        // $(cog1).on('mouseleave', function() {endCogAnimation(path)});

        // $(cog2).on('mouseenter', function() {startCogAnimation(path)});

        // $(cog2).on('mouseleave', function() {endCogAnimation(path)});

        // $(cog1).hover(function(){
        //     startCogAnimation(path);
        // });

        // $(cog2).hover(function(){
        //     startCogAnimation(path);
        // });
    }
})();



// WEBPACK FOOTER //
// ./client/src/site__fus078/components/svg-animation/index.js